export enum PaymentCardTypeId {
    Visa = 100000,
    Mastercard = 100001,
    Discover = 100002,
    AmericanExpress = 100003,
}

export enum PaymentTypeId {
    CreditCard = 100000,
    Cash = 100001,
    Check = 100003,
    GiftCertificate = 100004,
    DebitCard = 100005,
    GiftCard = 100006,
    CustomTender = 100007,
}

export enum SaleResponseStatusType {
    PartialApproval = 10000,
    Approval = 10001,
    InsufficientFundsDeclined = 10002,
    BadRequest = 10003
}

export enum TransactionStatusTypeId {
    Pending = 100000,
    Completed = 100001,
    Refunded = 100002,
    Cancelled = 100003,
    Failed = 100004,
    RefundedItems = 100005,
    Suspended = 100006,
    Resolved = 100007,
    PartiallyFailed = 100008,
    RefundedAmount = 100009,
    PartiallyCompleted = 100010,
    BadDebt = 100011
}

export enum TransactionTypeId {
    Normal = 100000,
    Refund = 100001,
    Split = 100002,
    OpenItemRefund = 100003,
    OpenAmountRefund = 100004
}

export enum NotificationResponseType {
  'partial',
  'full',
}

export enum ChannelType {
  Email = 1001,
  Text = 1002,
  QR = 1003,
  Merchant = 1004,
}
